<template lang="html">
  <v-form ref="form" lazy-validation>
    <v-card>
      <v-card-title>
        {{ $tc('label.usuario', 1) }}
      </v-card-title>
      <v-container grid-list-xl fluid>
        <metadados-container-layout
          v-if="metadadosUsuario"
          :metadados-entidade="metadadosUsuario"
          :objeto="usuario"
          :input-layout="inputLayout"
          :layout-class="layoutClass"
          :somente-leitura="somenteLeitura || isUsuarioExternoMaster"
          ref="containerUsuario">
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-select
              id="usuario-tipo"
              name="usuario-tipo"
              :label="$t('label.tipo_usuario')"
              :items="tiposUsuario"
              item-text="texto"
              item-value="valor"
              v-model="usuario.tipo"
              :disabled="!isNovoCadastro || somenteLeitura || isUsuarioExternoMaster"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroFuncionario">
            <v-text-field
              :label="$t('label.matricula')"
              v-model="usuario.matricula"
              maxlength="50"
              counter
              :disabled="somenteLeitura"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="`${$t('label.login')} *`"
              v-model="usuario.nomUsuario"
              required
              :rules="[rules.requiredText]"
              maxlength="100"
              counter
              :disabled="!isNovoCadastro || somenteLeitura"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-autocomplete
              id="usuario-perfil"
              class="custom-autocomplete"
              :disabled="somenteLeitura || isUsuarioExternoMaster"
              required
              :rules="[rules.required]"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="`${$tc('label.perfil', 1)} *`"
              v-model="usuario.idPerfil"
              :items="perfis"
              item-text="nomPerfil"
              item-value="id"
              :search-input.sync="searchInputPerfil"
              @click:append="triggerPerfil"
              @click.native="clickPerfil"
              clearable>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="`${$t('label.email')} *`"
              v-model="usuario.email"
              required
              :rules="[rules.requiredText]"
              maxlength="50"
              counter
              :disabled="somenteLeitura"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="`${$t('label.nome')} *`"
              v-model="usuario.nome"
              required
              :rules="[rules.requiredText]"
              maxlength="100"
              counter
              :disabled="somenteLeitura"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="$t('label.sobrenome')"
              v-model="usuario.sobrenome"
              maxlength="150"
              counter
              :disabled="somenteLeitura"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroFornecedor">
            <v-text-field
              :label="`${$t('label.cargo')} *`"
              v-model="usuario.cargo"
              maxlength="50"
              counter
              required
              :rules="[rules.requiredText]"
              :disabled="somenteLeitura"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroFornecedor">
            <v-text-field
              :label="`${$t('label.documento')} *`"
              v-model="usuario.documento"
              maxlength="50"
              counter
              required
              :rules="[rules.requiredText]"
              :disabled="somenteLeitura"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroFuncionario">
            <v-text-field
              :label="$t('label.cpf')"
              v-model="usuario.cpf"
              :disabled="somenteLeitura"
              v-mask="'###.###.###-##'"
              :return-masked-value="true"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroFuncionario">
            <v-autocomplete
              id="usuario-estruturausuario"
              class="custom-autocomplete"
              :disabled="somenteLeitura"
              required
              :rules="[rules.required]"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="`${$tc('label.estrutura_usuario', 1)} * `"
              v-model="usuario.idEstruturaUsuario"
              :items="estruturasUsuario"
              item-text="nomEstruturaUsuario"
              item-value="id"
              :search-input.sync="searchInputEstruturaUsuario"
              @click:append="triggerEstruturaUsuario"
              @click.native="clickEstruturaUsuario"
              @input="estruturaUsuarioSelecionada"
              clearable>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroFuncionario">
            <v-autocomplete
              id="usuario-superioresimediatos"
              class="custom-autocomplete"
              :disabled="!usuario.idEstruturaUsuario || somenteLeitura"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="$t('label.superior_imediato')"
              v-model="usuario.superioresImediatos"
              :items="superioresImediato"
              item-text="nomeCompleto"
              item-value="id"
              :search-input.sync="searchInputSuperiorImediato"
              @click:append="triggerSuperiorImediato"
              @click.native="clickSuperiorImediato"
              multiple
              chips
              deletable-chips>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroFuncionario">
            <v-autocomplete
              id="usuario-divisao"
              class="custom-autocomplete"
              :disabled="!usuario.idEstruturaUsuario || somenteLeitura"
              required
              :rules="[rules.requiredTags]"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="`${$tc('label.divisao', 1)} * `"
              v-model="usuario.idDivisoes"
              :items="divisoes"
              item-text="nome"
              item-value="id"
              :search-input.sync="searchInputDivisao"
              @click:append="triggerDivisao"
              @click.native="clickDivisao"
              multiple
              chips
              deletable-chips
              @input="divisaoSelecionada"
              return-object>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes"
            v-if="cadastroCliente">
            <v-autocomplete
              id="usuario-tipo-verba"
              class="custom-autocomplete"
              :disabled="somenteLeitura"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="`${$tc('label.tipo_verba', 1)}`"
              v-model="usuario.tiposVerba"
              :items="listaTiposVerba"
              item-text="nome"
              item-value="id"
              clearable
              multiple
              chips
              deletable-chips
              return-object>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" slot="depois" v-if="cadastroFornecedor">
            <v-switch
              color="primary"
              :label="$t('label.usuario_externo_master', {tipo_usuario: this.$tc('label.fornecedor', 1)})"
              :disabled="somenteLeitura"
              v-model="usuario.indUsuarioExternoMaster">
            </v-switch>
          </v-col>
          <v-col cols="12" sm="2" slot="depois">
            <v-switch
              color="primary"
              :label="$t('label.recebe_mail')"
              :disabled="somenteLeitura"
              v-model="usuario.indRecebeMail">
            </v-switch>
          </v-col>
          <v-col cols="12" sm="2" slot="depois">
            <v-switch
              color="primary"
              :label="$t('label.ativar_inativa')"
              :disabled="somenteLeitura"
              v-model="usuario.indAtivo">
            </v-switch>
            <v-switch color="primary"
              :label="$t('label.compoe_relatorio')"
              :disabled="somenteLeitura"
              v-model="usuario.relatUsuario"
              v-if="this.usuarioLogado.relatUsuario">
            </v-switch>
          </v-col>
        </metadados-container-layout>

        <div v-if="cadastroCliente">
          <hr class="primary" style="margin: 40px 0" />
          <v-row
            v-if="!somenteLeitura">
            <v-col cols="12" sm="4">
              <v-autocomplete
                id="usuario-cliente"
                class="custom-autocomplete"
                required
                :no-data-text="$t('message.nenhum_registro')"
                :label="`${$tc('label.cliente', 1)} * `"
                v-model="usuarioCliente"
                :items="clientes"
                item-text="codNome"
                item-value="id"
                :search-input.sync="searchInputCliente"
                @click:append="triggerCliente"
                @click.native="clickCliente"
                return-object
                clearable>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4">
              <v-switch
                color="primary"
                :label="$t('label.participa_aprovacao_acordo')"
                v-model="indAprovadorAcordo"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="4">
              <v-btn class="accent"
                @click="adicionarCliente"
                :disabled="!usuarioClienteAdicionavel">
                {{ $t('label.adicionar') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="cabecalhoClientes"
            :items="usuario.clientes"
            :no-data-text="$t('message.nenhum_cliente_adicionado')"
            hide-default-footer
            disable-pagination
            :items-per-page="-1">
            <template v-slot:item.participa_aprovacao_acordo="{ item }">
              <v-switch
                color="primary"
                v-model="item.indAprovadorAcordo"
                :disabled="somenteLeitura"
              ></v-switch>
            </template>
            <template v-slot:item.indAtivo="{ item }">
              <v-switch
                color="primary"
                v-model="item.indAtivo"
                :disabled="somenteLeitura"
              ></v-switch>
            </template>
          </v-data-table>
        </div>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="somenteLeitura" @click.native="cancel">{{ $t('label.voltar') }}</v-btn>
        <v-btn v-if="!somenteLeitura" @click.native="openCancelarDialog">{{ $t('label.cancelar') }}</v-btn>
        <v-btn v-if="!somenteLeitura" @click.native="openSaveDialog" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>

    <confirm
      ref="confirmDialog"
      :message="dialog.content"
      :persistent="true"
      @agree="save()">
    </confirm>

    <confirm
      ref="cancelarDialog" :title="$t('title.atencao')"
      :message="$t('message.tem_certeza_cancelar')"
      @agree="cancel">
    </confirm>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { montarEstruturaDinamica } from '../../common/functions/metadados';
import { generateComputed } from '../../common/functions/roles-computed-generator';
import Usuario from './Usuario';
import Confirm from '../../shared-components/vuetify/dialog/Confirm';
import MetadadosContainerLayout from '../../shared-components/metadados/MetadadosContainerLayout';

export default {
  name: 'UsuarioForm',
  props: {
    somenteLeitura: Boolean,
  },
  components: {
    Confirm,
    MetadadosContainerLayout,
  },
  computed: {
    ...mapGetters('metadados', [
      'getUsuarioMetadado',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'indModoVarejo',
      'indAmbienteProdutivo',
    ]),
    ...generateComputed('usr', [
      'canPost',
    ]),
    isNovoCadastro() {
      return !this.idUsuario;
    },
    cadastroFuncionario() {
      const ehCadastroFuncionario = this.usuario.tipo === 'FUNCIONARIO';

      if (ehCadastroFuncionario) {
        this.usuario.clientes = [];
      }

      return ehCadastroFuncionario;
    },
    cadastroCliente() {
      const ehCadastroCliente = this.usuario.tipo === 'CLIENTE';

      if (ehCadastroCliente) {
        this.usuario.matricula = undefined;
        this.usuario.idEstruturaUsuario = undefined;
        this.usuario.superioresImediatos = [];
        this.usuario.idDivisoes = [];
      }

      return ehCadastroCliente;
    },
    cadastroFornecedor() {
      const ehCadastroFornecedor = this.usuario.tipo === 'FORNECEDOR';

      if (ehCadastroFornecedor) {
        this.usuario.clientes = [];
        this.usuario.idEstruturaUsuario = undefined;
        this.usuario.superioresImediatos = [];
        this.usuario.idDivisoes = [];
        this.usuario.tiposVerba = [];
      }

      return ehCadastroFornecedor;
    },
    metadadosUsuario() {
      if (this.getUsuarioMetadado && this.getUsuarioMetadado.mapaEntidades) {
        return this.getUsuarioMetadado;
      }
      return undefined;
    },
    usuarioClienteAdicionavel() {
      return this.usuarioCliente
        && Object.keys(this.usuarioCliente).length > 0
        && this.usuarioCliente.id;
    },
    isUsuarioExternoMaster() {
      return this.usuarioLogado.indUsuarioExternoMaster;
    },
  },
  data() {
    return {
      usuarioResource: this.$api.usuario(this.$resource),
      perfilResource: this.$api.perfil(this.$resource),
      estruturaUsuarioResource: this.$api.estruturaUsuario(this.$resource),
      divisaoResource: this.$api.divisao(this.$resource),
      clienteResource: this.$api.cliente(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      resourceMetadado: this.$api.metadado(this.$resource),
      orcamentoTipoVerbaResource: this.$api.orcamentoTipoVerba(this.$resource),
      searchInputEstruturaUsuario: null,
      searchInputPerfil: null,
      searchInputSuperiorImediato: null,
      searchInputDivisao: null,
      searchInputCliente: '',
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredText: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
        requiredTags: (value) => value.length > 0 || this.$t('message.campo_obrigatorio'),
      },
      tiposUsuario: [],
      perfis: [],
      estruturasUsuario: [],
      estruturaUsuario: null,
      superioresImediato: [],
      divisoes: [],
      clientes: [],
      listaTiposVerba: [],
      extensoes: [],
      niveisExtensoes: [],
      nivel: {},

      usuario: new Usuario(),
      usuarioCliente: {},
      indAprovadorAcordo: false,

      inputLayout: {
        xs12: true,
        sm12: false,
        sm6: true,
        md3: false,
        md4: true,
        md6: false,
        md9: false,
        md12: false,
      },

      layoutClass: { wrap: true },

      cabecalhoClientes: [
        { text: this.$tc('label.cod_cliente', 1), sortable: true, value: 'idExterno' },
        { text: this.$tc('label.nome_cliente', 1), sortable: true, value: 'nomCliente' },
        { text: this.$t('label.participa_aprovacao_acordo'), value: 'participa_aprovacao_acordo', sortable: false },
        { text: this.$t('label.ativo'), value: 'indAtivo', sortable: false },
      ],
    };
  },
  watch: {
    searchInputPerfil(val) {
      if (this.usuario && this.usuario.idPerfil) {
        const selecao = this.perfis.filter((perfil) => perfil.id === this.usuario.idPerfil);
        if (selecao.length > 0 && selecao[0].nomPerfil === val) {
          return;
        }
      }

      if (this.timeoutPerfil) {
        window.clearTimeout(this.timeoutPerfil);
      }
      this.timeoutPerfil = window.setTimeout(() => {
        if (val != null) this.buscarPerfis(val);
      }, 500);
    },
    searchInputEstruturaUsuario(val) {
      if (this.usuario && this.usuario.idEstruturaUsuario) {
        const selecao = this.estruturasUsuario
          .filter((est) => est.id === this.usuario.idEstruturaUsuario);
        if (selecao.length > 0 && selecao[0].nomEstruturaUsuario === val) {
          return;
        }
      }

      if (this.timeoutEstrutura) {
        window.clearTimeout(this.timeoutEstrutura);
      }
      this.timeoutEstrutura = window.setTimeout(() => {
        if (val != null) this.buscarEstruturasUsuario(val);
      }, 500);
    },
    searchInputSuperiorImediato(val) {
      if (this.timeoutSuperiorImediato) {
        window.clearTimeout(this.timeoutSuperiorImediato);
      }
      this.timeoutSuperiorImediato = window.setTimeout(() => {
        if (val != null) this.buscarSuperioresImediatos(val);
      }, 500);
    },
    searchInputDivisao(val) {
      if (this.timeoutDivisao) {
        window.clearTimeout(this.timeoutDivisao);
      }
      this.timeoutDivisao = window.setTimeout(() => {
        if (val != null) this.buscarDivisoes(val);
      }, 500);
    },
    searchInputCliente(val) {
      if (this.usuarioCliente && this.usuarioCliente.codNome) {
        const selecao = this.usuarioCliente.codNome;
        if (selecao === val) {
          return;
        }
      }

      if (this.timeoutCliente) {
        window.clearTimeout(this.timeoutCliente);
      }
      this.timeoutCliente = window.setTimeout(() => {
        if (val != null) this.buscarClientes(val);
      }, 500);
    },
    cadastroFuncionario() {
      if (!this.cadastroFuncionario && this.isUsuarioExternoMaster) {
        this.montarCadastroUsuarioExterno();
      }
    },
  },
  methods: {
    ...mapActions('metadados', [
      'setUsuarioMetadado',
    ]),
    popularMetadadosUsuario() {
      if (this.getUsuarioMetadado) {
        return;
      }
      this.setUsuarioMetadado({
        resource: this.resourceMetadado.listarUsuario,
      });
    },
    limparFormulario() {
      this.usuario = new Usuario();
      this.$refs.form.reset();
    },
    cancel() {
      this.limparFormulario();
      this.$router.push({ name: 'usuario' });
    },
    buscarTipos() {
      this.tiposUsuario = [];
      return this.usuarioResource.tipos()
        .then((res) => {
          res.data.forEach((item) => {
            const tipo = {
              texto: this.$t(item.texto),
              valor: item.valor,
            };
            this.tiposUsuario.push(tipo);
            if (!this.$route.params.id) {
              if (this.indModoVarejo) {
                this.usuario.tipo = 'FORNECEDOR';
              } else {
                this.usuario.tipo = 'CLIENTE';
              }
            }
          }, this);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    estruturaUsuarioSelecionada() {
      // this.usuario.nomEstruturaUsuario = estruturaUsuario.nomEstruturaUsuario;
      // this.usuario.idEstruturaUsuario = estruturaUsuario.idEstruturaUsuario;
      // this.usuario.indRepresentante = estruturaUsuario.indRepresentante;
      this.usuario.superioresImediatos = [];
      this.usuario.divisoes = [];
      this.usuario.idDivisoes = [];
    },
    adicionarCliente() {
      if (this.usuario.clientes.find((item) => item.id === this.usuarioCliente.id)) {
        this.$toast(this.$t('errors.cliente.ja_adicionado'));
        return;
      }
      this.usuarioCliente.indAtivo = true;
      this.usuarioCliente.indAprovadorAcordo = this.indAprovadorAcordo;
      this.usuario.clientes.push(this.usuarioCliente);
      this.usuarioCliente = {};
      this.indAprovadorAcordo = false;
    },
    openCancelarDialog() {
      this.$refs.cancelarDialog.open();
    },
    openSaveDialog(ref, from) {
      if (!this.$refs.form.validate()) return;
      const content = this.$t('message.salvar_usuario');
      this.setDialogContent(content, this.save, from || this.dialog.from);
      this.$refs.confirmDialog.open();
    },
    montarCadastroUsuarioExterno() {
      this.buscarPerfis(null, this.usuarioLogado.idPerfil);
      this.buscarExtensoes();
    },
    buscarExtensoes() {
      const params = {
        idNivelExtensao: 3,
        indUsuarioExterno: true,
      };
      return this.extensaoResources.listarPorUsuario(params)
        .then((res) => {
          this.extensoes = res.data.resposta;
          if (this.extensoes.length === 1) {
            const [grupoForn] = this.extensoes;
            this.usuario.grupofornecedor = grupoForn;
            this.$refs.containerUsuario.refresh();
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    save() {
      const objArmazenamento = {
        ...this.usuario,
        ...this.$refs.containerUsuario.getValoresDependencias(),
      };

      if (this.usuario.tipo === 'CLIENTE' && !this.usuario.clientes.length) {
        this.$toast(this.$t('errors.cliente.obrigatorio'));
        return;
      }
      this.exibeAlertaLgpd();
      if (this.isNovoCadastro) {
        this.requestGravar(objArmazenamento, this.usuarioResource.gravar);
      } else {
        this.requestAtualizar(objArmazenamento, this.usuarioResource.atualizar);
      }
    },
    exibeAlertaLgpd() {
      if (this.indAmbienteProdutivo) return;

      const alertaLgpd = this.$t('message.lgpd');
      alert(alertaLgpd); // eslint-disable-line
    },
    requestAtualizar(object, resource) {
      resource({ id: object.id }, object)
        .then(() => {
          this.$router.push({ name: 'usuario' });
          this.$toast(this.$t('message.atualizado_com_sucesso'));
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    requestGravar(object, resource) {
      resource(object)
        .then(() => {
          this.$router.push({ name: 'usuario' });
          this.$toast(this.$t('message.adicionado_confira_tabela'));
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregarUsuario(id) {
      this.usuarioResource.buscar({ id })
        .then((res) => {
          this.editar(res.body);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    editar(usuario) {
      this.buscarEstruturasUsuario(null, usuario.idEstruturaUsuario)
        .then(() => {
          this.usuario = new Usuario();
          this.usuario.construirAPartirDaConsultaCompleta({ ...usuario });
          montarEstruturaDinamica(usuario, this.metadadosUsuario, this.usuario);
        })
        .then(() => this.buscarPerfis(null, this.usuario.idPerfil))
        .then(() => this.buscarDivisoes())
        .then(() => this.buscarTiposVerba())
        .then(() => this.buscarSuperioresImediatos());
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    triggerPerfil() {
      this.triggerClick('usuario-perfil');
    },
    clickPerfil() {
      this.buscarPerfis(this.searchInputPerfil);
    },
    buscarPerfis(content = '', idPerfil = null) {
      const params = {
        autocomplete: content,
      };
      if (idPerfil) {
        params.idPerfil = idPerfil;
      }
      return this.perfilResource.selecao(params)
        .then((res) => {
          this.perfis = res.data;
          if (this.perfis.length === 1) {
            this.usuario.idPerfil = this.perfis[0].id;
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    triggerEstruturaUsuario() {
      this.triggerClick('usuario-estruturausuario');
    },
    clickEstruturaUsuario() {
      this.buscarEstruturasUsuario(this.searchInputEstrutura);
    },
    buscarEstruturasUsuario(content, idEstruturaUsuario) {
      const param = {
        autocomplete: content,
      };
      if (idEstruturaUsuario) {
        param.id = idEstruturaUsuario;
      }
      return this.estruturaUsuarioResource.selecao(param)
        .then((res) => {
          this.estruturasUsuario = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    triggerSuperiorImediato() {
      this.triggerClick('usuario-superioresimediatos');
    },
    clickSuperiorImediato() {
      this.buscarSuperioresImediatos(this.searchInputSuperiorImediato);
    },
    buscarSuperioresImediatos(content = '') {
      const params = {
        nome: content,
        colunaOrdenacao: 'nome_completo',
      };
      if (this.usuario.idEstruturaUsuario) {
        params.idEstruturaUsuario = this.usuario.idEstruturaUsuario;
      }

      return this.usuarioResource.listarSuperior(params)
        .then((res) => {
          this.superioresImediato = res.data.resposta;
          if (this.usuario.superioresImediatos && this.usuario.superioresImediatos.length > 0) {
            this.superioresImediato = [...this.superioresImediato, ...this.usuario.superioresImediatos];
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    triggerDivisao() {
      this.triggerClick('usuario-divisao');
    },
    clickDivisao() {
      this.buscarDivisoes(this.searchInputDivisao);
    },
    divisaoJaInserida(idDivisao) {
      return this.usuario.divisoes
        .filter((divisao) => divisao.id === idDivisao).length > 0;
    },
    buscaDivisaoPorId(id) {
      return this.divisoes.filter((divisao) => divisao.id === id)[0];
    },
    divisaoSelecionada(divisoes) {
      this.usuario.divisoes = [];
      divisoes.forEach((divisao) => {
        if (Object.keys(divisao).length > 0 && !this.divisaoJaInserida(divisao.id)) {
          this.usuario.divisoes.push(divisao);
        } else if (!this.divisaoJaInserida(divisao)) {
          this.usuario.divisoes.push(this.buscaDivisaoPorId(divisao));
        }
      });
      this.usuario.idDivisoes = this.usuario.divisoes.map((divisao) => divisao.id);
    },
    buscarDivisoes(content = null) {
      const params = {
        autocomplete: content,
        cadastroUsuario: true,
      };
      if (this.usuario.idEstruturaUsuario) {
        params.idEstruturaUsuario = this.usuario.idEstruturaUsuario;
      }
      return this.divisaoResource.autocomplete(params)
        .then((res) => {
          this.divisoes = res.data;

          if (this.usuario.divisoes && this.usuario.divisoes.length > 0) {
            this.divisoes = [...this.divisoes, ...this.usuario.divisoes];
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscarTiposVerba() {
      return this.orcamentoTipoVerbaResource.buscarAtivos()
        .then((res) => {
          res.data.forEach((item) => {
            const tipoVerba = {
              id: item.id,
              nome: item.nome,
            };
            this.listaTiposVerba.push(tipoVerba);
          }, this);
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    triggerCliente() {
      this.triggerClick('usuario-cliente');
    },
    clickCliente() {
      this.buscarClientes(this.searchInputCliente);
    },
    buscarClientes(content) {
      const params = {
        autocomplete: content || '',
        limit: 100,
      };
      this.clienteResource.selecao(params)
        .then((res) => {
          this.clientes = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    triggerClick(id) {
      document.getElementById(id).click();
    },
  },
  beforeMount() {
    this.popularMetadadosUsuario();
    this.buscarTipos();
    this.buscarTiposVerba();
    if (this.$route.params.id) {
      this.idUsuario = parseInt(this.$route.params.id, 10);
      this.carregarUsuario(this.idUsuario);
    }
  },
};
</script>
